/**
 * Homepage FAQ copy.
 *
 * Kept apart from the FAQ section component so the homepage can build its
 * FAQPage structured data without pulling the component — and framer-motion
 * with it — into the critical bundle.
 */
import { business, offers } from "@/lib/business";

export const homeFaqs = [
  {
    q: "What areas does NIMAR serve?",
    a: `We work within roughly ${business.serviceRadiusMiles} miles of our Wakefield shop — including Reading, North Reading, Stoneham, Woburn, Lynnfield, Saugus, Malden, Melrose, Burlington, Lexington, Cambridge, Somerville and Danvers. If your town is not listed, call us anyway; we will tell you honestly whether we can cover it.`,
  },
  {
    q: "Do you charge for estimates?",
    a: "No. Every estimate is free and there is no obligation attached to it. We walk the property, talk through what you want, and send back a written scope with pricing so you know exactly what is included before deciding anything.",
  },
  {
    q: "Do you handle both landscaping and masonry, or do I need two contractors?",
    a: "Both, with one crew. That is the main reason clients call us — the patio, the retaining wall and the planting around them are designed together and installed by the same team, so nothing gets lost between two trades.",
  },
  {
    q: "How soon can you start?",
    a: "It depends on the season. Spring clean-ups and maintenance start-ups book out fastest, so those are worth locking in early. Hardscape and masonry projects are typically scheduled a few weeks out. We give you a real date rather than an optimistic one.",
  },
  {
    q: "What does weekly maintenance actually include?",
    a: "Mowing, string trimming around beds, fences and foundations, mechanical edging along walkways and driveways, and a full blow-down of every hard surface before we leave. We also adjust cut height through the season instead of running the same setting all year.",
  },
  {
    q: "Why does my patio or walkway keep sinking?",
    a: "Almost always the base. If the excavation was too shallow or the base was not compacted in lifts, New England frost cycles will move it every winter. We rebuild on a properly excavated and compacted base with drainage pitch, which is what stops it recurring.",
  },
  {
    q: "How do I know if my brick needs repointing?",
    a: "Run a key along a mortar joint. If it crumbles away as sand, or the joints have receded more than about a quarter inch, it needs repointing. Waiting until the brick faces start flaking turns a pointing job into a much more expensive brick replacement.",
  },
  {
    q: "Do you offer any discounts?",
    a: `Yes — two. ${offers.returning.detail} ${offers.referral.detail}`,
  },
  {
    q: "Are you insured?",
    a: `${business.legalName} is a registered Massachusetts corporation and carries insurance on all work. We are happy to provide a certificate before a project starts — just ask.`,
  },
];
